


export default function EmptyProperty(){
    return (
        <div className="empty_property">
          <span>ویژگی برای این دسته بندی تعریف نشده است.</span>
        </div>
    );
}